module.exports = __webpack_public_path__ + "img/logo.485c119a.png";